export enum OperationalRatesPermissionsEnum {
  View = 'OPERATIONAL_RATES.VIEW',
  ViewAssessmentControls = 'UNDERWRITING.ASSESSMENT.CONTROLS.VIEW',
  RequestAssessmentControls = 'UNDERWRITING.ASSESSMENT.CONTROLS.REQUEST',
  ActionAssessmentControls = 'UNDERWRITING.ASSESSMENT.CONTROLS.ACTION',
  ViewAnnuityValues = 'PENSIONS.ANNUITY_VALUES.VIEW',
  RequestAnnuityValues = 'PENSIONS.ANNUITY_VALUES.REQUEST',
  ActionAnnuityValues = 'PENSIONS.ANNUITY_VALUES.ACTION',
}
